// extracted by mini-css-extract-plugin
export default {"component":"SinglePayment_component__FC97a","dark":"SinglePayment_dark__HQBig"};